import { render, staticRenderFns } from "./ChartOfAccountImport.vue?vue&type=template&id=e1352234"
import script from "./ChartOfAccountImport.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports